// TODO: Fix typo for initial pending
export enum AsyncFetchStatus {
	INITIAL,
	INITIAL_PENDIG,
	IDLE,
	PENDING,
	SUCCESS,
	FAILED
}
